import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from './shared.module';
import { MatListModule } from '@angular/material/list';
import { OrganizationSwitcherDialogComponent } from '../components/modals/organization-switcher-dialog/organization-switcher-dialog.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { A11yModule } from '@angular/cdk/a11y';
import { LoadingOrErrorComponent } from '../components/loading-or-error/loading-or-error.component';
import { ToolbarComponent } from '../components/toolbar/toolbar.component';

const DECLARATIONS = [OrganizationSwitcherDialogComponent, ToolbarComponent];

const MODULES = [
  SharedModule,
  A11yModule,
  NgScrollbarModule,
  MatToolbarModule,
  MatSidenavModule,
  MatTooltipModule,
  MatListModule,
  LoadingOrErrorComponent,
  NgxPermissionsModule
];

@NgModule({
  declarations: DECLARATIONS,
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS]
})
export class ContentWrapperModule {}
